import {mapActions} from 'vuex';
export var formRegisterMixin = {
  data: () => ({
    isUpdate: false,
    formValid: false,
  }),
  methods: {
    ...mapActions({showLoadingDialog: 'dialogModule/setShowLoadingDialog',
                  setMessage: 'dialogModule/setLoadingDialogMessage'}),
    async submitForm() {
      if (!this.$refs.form.validate()) {
        this.$toasted.error('Verifique os campos em vermelho')
        return
      }
      try {
        this.setMessage('Enviando registro para o sistema')
        this.showLoadingDialog(true);
        let response
        if (!this.isUpdate) {
          response = await this.insert(this.form)
        } else {
          response = await this.update({
            ...this.form,
            id: this.$route.params.id,
          })
        }
        this.$toasted.success(response);

        this.$refs.form.reset()
        this.$refs.form.resetValidation()
      } catch (error) {
        this.$toasted.error(error, {duration: null});
      } finally {
        this.showLoadingDialog(false);
      }
    },

    goBack() {
      let rota = this.$route.path
      rota = rota.split('/')
      // ir para rota principal ex: this.$route.path = /empresas/new || apos o split:  [0]="" [1]="empresas" [2]="register"
      // this.$router.push({ name: "empresa" });
      this.$router.push(`/${rota[1]}`)
    },
  },
}
